import { cached } from '@porotutu/react'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { permittedRoute, signedInRoute } from '@/router/root'
import { summaryQuery } from './queries'

export const dashboardRoute = createRoute({
  getParentRoute: () => signedInRoute,
  beforeLoad: permittedRoute('dashboard'),
  path: '/dashboard',
  loader: ({ context }) => context.queryClient.query(cached(summaryQuery())),
  component: lazyRouteComponent(() => import('./pages'), 'DashboardPage'),
})

export const dashboardRoutes = [dashboardRoute]
